import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  OnChanges,
  SimpleChanges,
  ViewChild,
  Input,
  HostListener,
  AfterViewChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { ResidentialDirective } from '../residential.directive';
import { InterfaceComponent } from '../interface-component';
import { ResidentialService } from '../residential.service';
import { AddComponent } from '../add-component';
import { _ } from 'underscore';
import { Event as NavigationEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationStart } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PlatformLocation } from '@angular/common';
// import { CanComponentDeactivate } from '../can-deactivate-guard.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {NgbModal, NgbActiveModal, NgbModule, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { ElementRef, NgZone } from '@angular/core';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import * as $ from 'jquery';
@Component({
  selector: 'app-residential-question',
  templateUrl: './residential-question.component.html',
  styleUrls: ['./residential-question.component.css'],
})
export class ResidentialQuestionComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  @ViewChild(ResidentialDirective, { static: true })
  appResidential: ResidentialDirective;
  @Input() questions: AddComponent[];

  public question;
  private message;
  private userResponses: Array<any> = [];
  currentAdIndex = 0;
  backButton: Boolean = false;
  showBack = false;
  previous;
  deviceWidth;
  currentId;
  nextId;
  selectedServiceType;
  showNextId = false;
  selectedSwitchingId;
  selectedTerm;
  showPrepaid = false;
  showThunder = false;
  showOwn = false;
  IsWeb = false;
  percentage = 0;
  PlanCount = 0;
  ProviderCount =0;
  resQues: AddComponent[] = [];
  login: boolean;
  questionHeights = [];
  modalRef: BsModalRef;
  @ViewChild('template', { static: true }) template: ElementRef;
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  ShowError = false;
  ErrorMsg ="";
  // To check renewal
  questionFlowType;

  // API Url
  url = environment.api_url;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private residentialService: ResidentialService,
    private router: Router,
    private location: PlatformLocation,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private _scrollToService: ScrollToService,
    private modalService: BsModalService
  ) {
    if (_.isEmpty(this.deviceWidth)) {
      this.residentialService.deviceWidth = window.innerWidth;
      this.deviceWidth = window.innerWidth;
    }
    if (!_.isEmpty(sessionStorage.getItem('userResponse'))) {
      this.userResponses = JSON.parse(
        sessionStorage.getItem('userResponse')
      ).userResponses;
      this.residentialService.userResponse.userResponses = this.userResponses;
      if (_.findWhere(this.userResponses, { fieldValue: 'Standard Switch' })) {
        this.residentialService.setNextId('008');
      }
      if (_.findWhere(this.userResponses, { res_question_id: '0026' })) {
        const term = _.findWhere(this.userResponses, {
          res_question_id: '0026',
        });
        this.residentialService.selectedTermId = term.fieldValue;
      }
      this.residentialService.filter(this.userResponses);
    }
    if (
      !_.isEmpty(sessionStorage.getItem('questionStatusObj')) &&
      sessionStorage.getItem('questionStatusObj') !== undefined && sessionStorage.getItem('questionStatusObj') !== "undefined"
    ) {
      this.residentialService.questionnaireStatusObj = JSON.parse(
        sessionStorage.getItem('questionStatusObj')
      );
      this.residentialService.property = this.residentialService
        .questionnaireStatusObj
        ? this.residentialService.questionnaireStatusObj.property
        : '';
      this.residentialService.service = this.residentialService
        .questionnaireStatusObj
        ? this.residentialService.questionnaireStatusObj.type
        : '';
    }
    if (this.residentialService.user) {
      this.login = true;
    } else {
      this.login = false;
    }

    location.onPopState(() => {
     if(this.deviceWidth > 768)
     {
      // if (this.residentialService.currentId !== '001') {
      //   history.forward();
      //   this.login = true;
      // }

      window.location.href = environment.aap_url;

     }
     
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler($event) {
    $event.returnValue = false;
    const questionStatusObj = {
      questionStatus: 'Quitted',
      questionStep: this.residentialService.currentId,
      type: this.residentialService.service,
      property: this.residentialService.property,
      percentage: this.percentage,
    };
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(questionStatusObj)
    );
    setTimeout(() => {
      // return this.router.navigateByUrl('/skippage');
      return this.residentialService.quitFlow();
    }, 50);
  }

  ngOnInit() {
   

    if(this.deviceWidth > 768)
    {
      this.IsWeb = true;

    }

    const queryString = window.location.search;
    //console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    const zipcode = urlParams.get('zipcode')
    const Utilitycode = urlParams.get('utilitycode')
    const Affiliate = urlParams.get('Affiliate')
    const Promo = urlParams.get('Promo')
    const ref = urlParams.get('ref')
 

    //console.log(product);

    // if(Affiliate != null)
    // {
    //   sessionStorage.setItem('_Affiliate',Affiliate)
      
    // }else
    // {
    //   sessionStorage.removeItem('_Affiliate')
    // }

    // if(Promo != null)
    // {
    //   sessionStorage.setItem('_Promo', Promo)
      
    // }else
    // {
    //   sessionStorage.removeItem('_Promo')
    // }
    
    sessionStorage.removeItem('_Affiliate');
    sessionStorage.removeItem('_Promo');

    if(Affiliate != null)
    {
      var u = this.removeURLParameter(window.location.href,'Affiliate')
      u = this.removeURLParameter(u,'Promo')
      window.history.pushState({}, document.title, u);
      
      var Promo_ = Promo == null ? "" :Promo;
      this.residentialService.UpdateAffliateStatus().subscribe((res: any) => {
        this.residentialService.ValidateAffiliatePromo(Affiliate,Promo_).subscribe((res: any) => {
        
          if(res.Status == "Success")
          {
            
            sessionStorage.setItem('_Affiliate',res.AffiliateName)
            sessionStorage.setItem('_AffiliateID',res.AffiliateID)
            if(res.PromoCode != "")
            {
              sessionStorage.setItem('_Promo',res.PromoCode)
            }
          }
          else
          {
            sessionStorage.removeItem('_Affiliate');
            sessionStorage.removeItem('_Promo');
          }
        
        });
      
      });
   


    }else if (Promo != null)
    {

      
      var u = this.removeURLParameter(window.location.href,'Promo')
      window.history.pushState({}, document.title, u);
      
      var Promo_ = Promo == null ? "" :Promo;
      this.residentialService.UpdateAffliateStatus().subscribe((res: any) => {
        this.residentialService.ValidateAffiliatePromo(null,Promo_).subscribe((res: any) => {
        
          if(res.Status == "Success")
          {
            
            if(res.PromoCode != "")
            {
              sessionStorage.setItem('_Promo',res.PromoCode)
            }
          }
          else
          {
            
            sessionStorage.removeItem('_Promo');
          }
        
        });
      
      });
   

    }
    else if (ref != null)
    {

      
      var u = this.removeURLParameter(window.location.href,'ref')
      window.history.pushState({}, document.title, u);
      
      var ref_ = ref == null ? "" :ref;
      
       if(ref_ != "")
       {
          sessionStorage.setItem('_Promo',ref_)
          sessionStorage.setItem('_Affiliate',"Friend / Family")
       }
       else
       {
            
         sessionStorage.removeItem('_Promo');
         sessionStorage.removeItem('_Affiliate');
       }
   

    }
    else
    {
      sessionStorage.removeItem('_Affiliate');
      sessionStorage.removeItem('_Promo');
    }
   
    if(zipcode != null && Utilitycode != null)
    {
       //console.log(zipcode);
      var u = this.removeURLParameter(window.location.href,'zipcode')
      u = this.removeURLParameter(u,'utilitycode')
      window.history.pushState({}, document.title, u);
      sessionStorage.setItem('zipcode',zipcode)
      sessionStorage.setItem('utilitycode',Utilitycode)
      //this.openModal(this.template);
        sessionStorage.removeItem('userResponse')
        sessionStorage.removeItem('questionStatusObj')
        this.router.navigateByUrl('/pre-success');
      //$('.modal-content').addClass("modalradius")


      this.residentialService.validateZipCode(zipcode).subscribe((res: any) => {
        if (res === `ZipCode: ${zipcode} did not return any TDSPs.`) {
          this.ShowError = true;
          this.ErrorMsg = res;
          this.openModal(this.template);

        } else {
         
          if(res != null)
          {

            var exists = res.filter(x => x.UtilityCode.toLowerCase() == Utilitycode.toLowerCase());
            if(exists.length != 0){
              //console.log(exists);

              sessionStorage.setItem('utilitycode',exists[0].UtilityCode)

              const user = {
                "utilityName": exists[0].UtilityCode,
                "sqFt":"btw_1250_2250",
                "dwellingtype":"Apartment",
                "zipcode":zipcode
              };

              this.residentialService.getRecommendationsCountByUtility(user).subscribe((res: any) => { 
              

                if(res != null)
                {
                  this.PlanCount = res["ProductCount"];
                  this.ProviderCount = res["ProviderCount"];
                
                  
                }

              
          

              });

           
            

            }else
            {
              this.ShowError = true;
              this.ErrorMsg = "TDSP not exists in provided zipcode";
              this.openModal(this.template);
            }

          }




        }
      
      });

      

    }else
    {
      //this.closeModalWithOutContact();
      sessionStorage.removeItem('zipcode')
      sessionStorage.removeItem('utilitycode')
      sessionStorage.removeItem('widthoutQuestionUserRequest')
      
      sessionStorage.removeItem('userObj');
    }




    this.deviceWidth = this.residentialService.deviceWidth;
    this.questionFlowType = this.residentialService.questionFlowType;
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
    try
    {
      this.userResponses = this.residentialService.userResponse.userResponses;
    }catch{

    }
   

    this.residentialService.currentunSelect.subscribe((message) => {
      if (!_.isEmpty(message)) {
        const viewContainerRef = this.appResidential.viewContainerRef;
        const containerLength = viewContainerRef.length;
        const question = _.findWhere(this.question, {
          _id: message['currentId'],
        });
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        let initial;
        const findService = _.findWhere(
          this.residentialService.userResponse.userResponses,
          { res_question_id: '002' }
        );
        if (findService !== undefined) {
          if (findService.fieldValue === 'Switching Providers') {
            const foundElem = _.findWhere(
              this.residentialService.userResponse.userResponses,
              { res_question_id: '005' }
            );
            if (
              foundElem !== undefined ||
              question._id === '004' ||
              question._id === '003' ||
              question._id === '001'
            ) {
              initial = this.question.indexOf(question) + 1;
            } else {
              initial = this.question.indexOf(question);
            }
          } else {
            initial = this.question.indexOf(question) + 1;
          }
        } else {
          initial = this.question.indexOf(question) + 1;
        }
        if (containerLength > initial) {
          for (let i = initial; i < containerLength; i++) {
            viewContainerRef.remove(i);
            // console.log.log(i, 'remove');
            this.cd.detach();
            // to avoid attemp to detect destroyed changes error
            if (!this.cd['destroyed']) {
              this.cd.detectChanges();
            }
          }
        }
      }
    });
    this.residentialService.currentMessage.subscribe((message) => {
      this.userResponses = this.residentialService.userResponse.userResponses;
      if (!_.isEmpty(this.userResponses) && this.userResponses.length > 1) {
        this.residentialService.filter(this.userResponses);
        this.filter();
      }
      this.message = message;
      if (_.isEmpty(message)) {
      } else {
        this.showBack = true;
        if (this.deviceWidth > 768) {
          if (
            message['currentId'] !== '000' &&
            message['questionStatus'] !== 'Quitted'
          ) {
            this.getLoaderImage(message);
          }
        }
        if (this.message.service) {
          for (let i = 0; i < this.question.length; i++) {
            if (this.question[i]._id === this.message.currentId) {
              if (this.deviceWidth > 768) {
                this.loadComponent(this.question[i + 1]);
              } else {
                this.loadComponentMob(this.question[i + 1]);
              }
            }
          }
        } else if (!_.isEmpty(this.message.nextId)) {
          for (let i = 0; i < this.question.length; i++) {
            if (this.question[i]._id === this.message.nextId) {
              if (this.deviceWidth > 768) {
                this.loadComponent(this.question[i]);
              } else {
                this.loadComponentMob(this.question[i]);
              }
            }
          }
        } else {
         
          var gotozero = true;
          if (_.isEmpty(sessionStorage.getItem('userObj')))
          {
            //this.message.currentId = this.message.currentId === '0032' ? '001' : this.message.currentId;
            if(this.message.currentId === '0032' || this.message.currentId === '0030-Deleted' || this.message.currentId === '0027')
            {
              var lst = this.userResponses.filter(x => x.res_question_id != "0032" && x.res_question_id != '0027' && x.res_question_id != '0030-Deleted');
              this.message.currentId =  lst[lst.length - 2].res_question_id;
              this.message.currentId = "001";
              gotozero = false;
            // this.router.navigate(['/pre-success'], {
            
            // });
            }
        }else
        {
          if(this.message.currentId === '0032' || this.message.currentId === '0030-Deleted' || this.message.currentId === '0027')
          {
            var lst = this.userResponses.filter(x => x.res_question_id != "0032" && x.res_question_id != '0027' && x.res_question_id != '0030-Deleted');
            this.message.currentId =  lst[lst.length - 2].res_question_id;
           // this.message.currentId = "001";
            //gotozero = false;
          // this.router.navigate(['/pre-success'], {
          
          // });
          }

        }
          
          if (this.message.currentId === '000') {
            this.residentialService.setServiceType('');
            //this.questions = this.residentialService.getQues();
            this.loadComponent(this.questions[0]);
            this.question = this.questions;
          } else {
            for (let i = 0; i < this.question.length; i++) {
              if (this.question[i]._id === this.message.currentId) {
                if (this.deviceWidth > 768) {
              
                  if(!gotozero)
                  {
                    this.loadComponent(this.question[i]);
                  }else
                  {
                    this.loadComponent(this.question[i + 1]);

                  }
                
                  
                  
                } else {
                  this.loadComponentMob(this.question[i + 1]);
                }
              }
            }
          }
        }
      }
    });
  }

  ngAfterViewChecked(): void {
    try{
      if (this.login === true) {
        this.userResponses = this.residentialService.userResponse.userResponses;
        const ids = [];
        _.each(this.userResponses, function (item) {
          ids.push(item.res_question_id);
        });
        for (let i = 0; i < ids.length; i++) {
          this.getLoaderImage({ currentId: ids[i] });
        }
        this.login = false;
      }
      this.questionFlowType = this.residentialService.questionFlowType;
      // to avoid attemp to detect destroyed changes error
      if (!this.cd['destroyed']) {
        this.cd.detectChanges();
      }
    }catch{


    }
  
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log.log(this.questions);
    try{

      if (changes.questions) {
        this.question = changes.questions.currentValue;
        if (!_.isEmpty(this.userResponses) && !_.isEmpty(this.question)) {
          const findService = _.findWhere(this.userResponses, {
            res_question_id: '002',
          });
          if (this.deviceWidth > 768) {
            if (findService && _.has(findService, 'fieldValue')) {
              this.residentialService.service = findService.fieldValue;
              if (
                !_.isEmpty(
                  this.userResponses[this.userResponses.length - 1].fieldValue
                )
              ) {
                if (
                  this.userResponses[this.userResponses.length - 1]
                    .res_question_id === '004' &&
                  this.userResponses[this.userResponses.length - 1].fieldValue ===
                    'Standard Switch'
                ) {
                  this.residentialService.messageService({
                    currentId:
                      this.userResponses[this.userResponses.length - 1]
                        .res_question_id,
                    nextId: '008',
                    questionStatus:
                      this.residentialService.questionnaireStatusObj
                        .questionStatus,
                  });
                } else if (
                  this.userResponses[this.userResponses.length - 1]
                    .res_question_id === '0026' &&
                  this.residentialService.service === 'Switching Providers' &&
                  this.userResponses[this.userResponses.length - 1].fieldValue !==
                    'PrePaid'
                ) {
                  this.residentialService.messageService({
                    currentId:
                      this.userResponses[this.userResponses.length - 1]
                        .res_question_id,
                    nextId: '0028',
                    questionStatus:
                      this.residentialService.questionnaireStatusObj
                        .questionStatus,
                  });
                } else if (
                  this.userResponses[this.userResponses.length - 1]
                    .res_question_id === '0026' &&
                  this.residentialService.service === 'New Service'
                ) {
                  try{
                    this.residentialService.messageService({
                      currentId:
                        this.userResponses[this.userResponses.length - 2]
                          .res_question_id,
                      questionStatus:
                        this.residentialService.questionnaireStatusObj
                          .questionStatus,
                    });
                  }catch{
  
                  }
             
                } else if (
                  this.userResponses[this.userResponses.length - 1]
                    .res_question_id === '0031' &&
                  this.residentialService.service === 'Switching Providers'
                ) {
                  this.residentialService.messageService({
                    currentId:
                      this.userResponses[this.userResponses.length - 2]
                        .res_question_id,
                    questionStatus:
                      this.residentialService.questionnaireStatusObj
                        .questionStatus,
                  });
                } else {
                  this.residentialService.messageService({
                    currentId:
                      this.userResponses[this.userResponses.length - 1]
                        .res_question_id,
                    questionStatus:
                      this.residentialService.questionnaireStatusObj
                        .questionStatus,
                  });
                }
              } else {
                this.residentialService.messageService({
                  currentId:
                    this.userResponses[this.userResponses.length - 2]
                      .res_question_id,
                  questionStatus:
                    this.residentialService.questionnaireStatusObj.questionStatus,
                });
              }
              this.login = true;
            } else if ((this.userResponses.length = 1)) {
              const findName = _.findWhere(this.userResponses, {
                fieldName: 'first_name',
              });
              if (!_.isEmpty(findName.fieldValue)) {
                this.residentialService.messageService({
                  currentId: '001',
                });
              } else {
                this.loadComponent(this.question[0]);
              }
            } else {
              this.loadComponent(this.question[0]);
            }
          } else {
            this.loadComponent(this.question[0]);
          }
        }
        if (_.isEmpty(this.userResponses)) {
          this.showBack = false;
          this.residentialService.setServiceType('');
          this.getLoaderImage({ currentId: '001' });
          this.loadComponent(this.question[0]);
        }
      }
      this.questionFlowType = this.residentialService.questionFlowType;
      setInterval(() => {
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }, 1000);

    }catch{

    }
    
  }

  // To load the image dynamically for loader on next action
  getLoaderImage(message) {
    this.questionFlowType = this.residentialService.questionFlowType;
    // to avoid attemp to detect destroyed changes error
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }

    this.selectedServiceType = this.residentialService.selectedType;
    this.selectedSwitchingId = this.residentialService.selectedNextId;

    if (message.currentId === '0026') {
      this.selectedTerm = this.residentialService.selectedTermId;
    } else {
      this.selectedTerm = '';
    }
    if (message.currentId === '000') {
      this.showThunder = true;
      this.percentage += 0;
    }
    if (message.currentId === '001') {
      this.showThunder = true;
      this.percentage += 2;
    }
    if (message.currentId === '0010' && message.rent_own === 'Own') {
      this.showOwn = true;
    } else if (message.rent_own === 'Rent') {
      this.showOwn = false;
    }

    if (this.residentialService.questionFlowType === 'renewal') {
      // console.log.log('renewal flow::::::::::');
      this.percentage += 5;
      // replace image src by active thunder
      if (
        message.currentId === '0016' ||
        message.currentId === '0020' ||
        message.currentId === '0021'
      ) {
        const imgObj = document.getElementById('thunder' + message.currentId);
        if (imgObj) {
          imgObj['parentElement'].classList.add('active');
          imgObj['parentElement'].classList.remove('disableimg');
          imgObj['src'] = 'assets/images/activethunder.png';
        }
      } else if (message.currentId === '0025') {
        this.percentage = 100;
        const imgObj = document.getElementById('home');
        if (imgObj) {
          imgObj['src'] = 'assets/images/activehome.png';
        }
      } else if (message.currentId !== '001') {
        // replace image src by active dot
        const imgObj = document.getElementById('dot' + message.currentId);
        if (imgObj) {
          imgObj['parentElement'].classList.add('active');
          imgObj['parentElement'].classList.remove('disableimg');
          imgObj['src'] = 'assets/images/activedot.png';
        }
      }
    } else {
      if (this.selectedServiceType === 'New Service') {
        this.percentage += 5;
        // replace image src by active thunder
        if (
          message.currentId === '0010' ||
          message.currentId === '0015' ||
          message.currentId === '0023'
        ) {
          const imgObj = document.getElementById('thunder' + message.currentId);
          if (imgObj) {
            imgObj['parentElement'].classList.add('active');
            imgObj['parentElement'].classList.remove('disableimg');
            imgObj['src'] = 'assets/images/activethunder.png';
          }
        } else if (message.currentId === '0025') {
          // if (this.selectedTerm === 'PrePaid') {
          //   this.showPrepaid = true;
          this.percentage = 100;
          const imgObj = document.getElementById('home');
          if (imgObj) {
            imgObj['src'] = 'assets/images/activehome.png';
          }
          // }
        } else if (message.currentId !== '001') {
          // replace image src by active dot
          const imgObj = document.getElementById('dot' + message.currentId);
          if (imgObj) {
            imgObj['parentElement'].classList.add('active');
            imgObj['parentElement'].classList.remove('disableimg');
            imgObj['src'] = 'assets/images/activedot.png';
          }
        }
      } else if (this.selectedServiceType === 'Switching Providers') {
        if (this.selectedSwitchingId === '008') {
          this.percentage += 4;
          this.showNextId = true;
          if (this.selectedTerm === 'PrePaid') {
            this.showPrepaid = true;
            if (message.currentId === '0028') {
              const imgObj = document.getElementById(
                'thunder' + message.currentId
              );
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activethunder.png';
              }
            } else if (message.currentId === '0030') {
              const imgObj = document.getElementById('home');
              this.percentage = 100;
              if (imgObj) {
                imgObj['src'] = 'assets/images/activehome.png';
              }
            } else if (message.currentId !== '001') {
              // replace image src by active dot
              const imgObj = document.getElementById('dot' + message.currentId);
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activedot.png';
              }
            }
          } else {
            if (
              message.currentId === '009' ||
              message.currentId === '0014' ||
              message.currentId === '0020' ||
              message.currentId === '0028'
            ) {
              const imgObj = document.getElementById(
                'thunder' + message.currentId
              );
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activethunder.png';
              }
            } else if (message.currentId === '0030') {
              const imgObj = document.getElementById('home');
              this.percentage = 100;
              if (imgObj) {
                imgObj['src'] = 'assets/images/activehome.png';
              }
            } else if (message.currentId !== '001') {
              // replace image src by active dot
              const imgObj = document.getElementById('dot' + message.currentId);
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activedot.png';
              }
            }
          }
        } else {
          this.showNextId = false;
          if (this.selectedTerm === 'PrePaid') {
            this.showPrepaid = true;
            this.percentage += 3;
            if (message.currentId === '0030') {
              const imgObj = document.getElementById('home');
              if (imgObj) {
                imgObj['src'] = 'assets/images/activehome.png';
              }
            } else if (message.currentId !== '001') {
              // replace image src by active dot
              const imgObj = document.getElementById('dot' + message.currentId);
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activedot.png';
              }
            }
          } else {
            this.percentage += 4;
            if (
              message.currentId === '005' ||
              message.currentId === '0012' ||
              message.currentId === '0017' ||
              message.currentId === '0025'
            ) {
              const imgObj = document.getElementById(
                'thunder' + message.currentId
              );
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activethunder.png';
              }
            } else if (message.currentId === '0030') {
              const imgObj = document.getElementById('home');
              if (imgObj) {
                imgObj['src'] = 'assets/images/activehome.png';
              }
            } else if (message.currentId !== '001') {
              // replace image src by active dot
              const imgObj = document.getElementById('dot' + message.currentId);
              if (imgObj) {
                imgObj['parentElement'].classList.add('active');
                imgObj['parentElement'].classList.remove('disableimg');
                imgObj['src'] = 'assets/images/activedot.png';
              }
            }
          }
        }
      }
    }
    if(this.percentage <= 100)
    {
      sessionStorage.setItem('percentage', JSON.stringify(this.percentage));
    }
   
  }

  loadComponent(question) {
    if(question.component != undefined)
    {
      const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(question.component);
      const viewContainerRef = this.appResidential.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(componentFactory);
      (<InterfaceComponent>componentRef.instance).data = question._id;
    }
    
  }

  loadComponentMob(question) {
    const viewContainerRef = this.appResidential.viewContainerRef;
    const containerLength = viewContainerRef.length;
    if (containerLength > this.question.indexOf(question)) {
      for (let i = this.question.indexOf(question); i < containerLength; i++) {
        viewContainerRef.remove(i);
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
      // console.log.log('get', viewContainerRef.get(this.question.indexOf(question)));
      const getId = document.getElementById(question._id);
      if (getId == null) {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<InterfaceComponent>componentRef.instance).data = question._id;
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
    } else if (!_.isEmpty(this.message) && this.message.nextId === '008') {
      for (let i = 4; i < containerLength; i++) {
        viewContainerRef.remove(i);
        // console.log.log(i, 'remove');
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
      const getId = document.getElementById(question._id);
      if (getId == null) {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<InterfaceComponent>componentRef.instance).data = question._id;
        this.cd.detach();
        this.cd.detectChanges();
        this.percentage += 4;
      }
    } else if (!_.isEmpty(this.message) && this.message.nextId === '0028') {
      let initial;
      const foundElem = _.findWhere(
        this.residentialService.userResponse.userResponses,
        { res_question_id: '005' }
      );
      if (foundElem !== undefined) {
        initial = 21;
      } else {
        initial = 20;
      }
      for (let i = initial; i < containerLength; i++) {
        viewContainerRef.remove(i);
        // console.log.log(i, 'remove');
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
      const getId = document.getElementById(question._id);
      if (getId == null) {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<InterfaceComponent>componentRef.instance).data = question._id;
        this.cd.detach();
        this.cd.detectChanges();
      }
      this.percentage += 4;
    } else {
      const getId = document.getElementById(question._id);
      if (getId == null) {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<InterfaceComponent>componentRef.instance).data = question._id;
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
      this.percentage += 4;
    }
    if (containerLength > 1) {
      
      this.triggerScrollTo(question._id);
      this.mapHeights(question._id, scrollTo);
    }

    if(this.percentage <= 100)
    {
      sessionStorage.setItem('percentage', JSON.stringify(this.percentage));
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    //this._scrollToService.scrollTo(config);

    if("0030" == destination)
    {
      
      destination = "0030_";
    }

    if(this.getOS == null || this.getOS() == "iOS")
    {
        setTimeout(() => {
              $("#" + destination)[0].scrollIntoView();
            }, 500);
    }
    else
    {

      // $('html, body').animate(
      //   { scrollTop: $('#' + (destination)).offset().top - 80 }
        
      // );

      setTimeout(() => {
        $("#" + destination)[0].scrollIntoView();
      }, 500);
    }
   

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  mapHeights(_id, scrollTo) {
    const foundElem = _.findWhere(this.questionHeights, { _id: _id });
    if (foundElem === undefined) {
      this.questionHeights.push({ _id: _id, height: scrollTo });
    } else {
      this.questionHeights = _.map(
        this.questionHeights,
        function (item, index) {
          if (item._id === _id) {
            item = { _id: _id, height: scrollTo };
          }
          return item;
        }
      );
    }
  }

  back() {
    this.backButton = true;
    this.userResponses = this.residentialService.userResponse.userResponses;
    if (this.userResponses.length > 1) {
      this.filter();
    }
    this.currentId = this.residentialService.currentId;
    for (let i = 0; i < this.question.length; i++) {
      if (this.question[i]._id === this.currentId) {
        let prevObj;
        if (this.currentId === '008') {
          prevObj = _.findWhere(this.userResponses, { res_question_id: '004' });
        } else if (this.currentId === '0028') {
          prevObj = _.findWhere(this.userResponses, {
            res_question_id: '0026',
          });
        } else if (this.currentId === '0014') {
          prevObj = _.findWhere(this.userResponses, {
            res_question_id: '0010',
          });
        }
        // For back handling of 'Pre-Paid' option
        if (
          !_.isEmpty(prevObj) &&
          prevObj.fieldValue !== 'PrePaid' &&
          this.question[i]._id === '0028'
        ) {
          this.previous = this.question[i - 2];
        }
        // For back handling of 'Standard Switch' option
        else if (
          !_.isEmpty(prevObj) &&
          prevObj.fieldValue !== 'Self-Selected Switch' &&
          this.question[i]._id === '008'
        ) {
          this.previous = this.question[i - 2];
        }
        // For back handling of 'Rent' option
        else if (
          !_.isEmpty(prevObj) &&
          prevObj.fieldValue === 'Rent' &&
          this.question[i]._id === '0014'
        ) {
          this.previous = this.question[i - 2];
        } else {
          this.previous = this.question[i - 1];
        }
      }
    }
    // console.log.log('previous', this.previous);
    this.loadComponent(this.previous);
    if (this.previous._id === '001') {
      this.showBack = false;
    }
    if (this.currentId === '0027') {
      this.showPrepaid = false;
    }
    if (this.currentId === '002') {
      this.residentialService.setServiceType('');
    }
    this.hideLoaderImage(this.previous._id);
  }
  hideLoaderImage(message) {
    this.selectedServiceType = this.residentialService.selectedType;
    if (message === '001') {
      this.showThunder = false;
      this.percentage -= 2;
    }
    if (this.selectedServiceType === 'New Service') {
      this.percentage -= 5;
      if (
        message === '001' ||
        message === '0010' ||
        message === '0015' ||
        message === '0023'
      ) {
        const imgObj = document.getElementById('thunder' + message);
        imgObj['parentElement'].classList.remove('active');
        imgObj['parentElement'].classList.add('disableimg');
        imgObj['src'] = 'assets/images/disablethunder.png';
      } else if (message === '0025') {
        const imgObj = document.getElementById('home');
        imgObj['parentElement'].classList.remove('active');
        imgObj['parentElement'].classList.add('disableimg');
        imgObj['src'] = 'assets/images/disablehome.png';
      } else {
        const imgObj = document.getElementById('dot' + message);
        imgObj['parentElement'].classList.remove('active');
        imgObj['parentElement'].classList.add('disableimg');
        imgObj['src'] = 'assets/images/disabledot.png';
      }
    } else if (this.selectedServiceType === 'Switching Providers') {
      if (this.showNextId === true) {
        this.percentage -= 4;
        if (this.selectedTerm === 'PrePaid') {
          if (message === '0028') {
            const imgObj = document.getElementById('thunder' + message);
            imgObj['parentElement'].classList.remove('active');
            imgObj['parentElement'].classList.add('disableimg');
            imgObj['src'] = 'assets/images/disablethunder.png';
          } else if (message === '0030') {
            const imgObj = document.getElementById('home');
            imgObj['parentElement'].classList.remove('active');
            imgObj['parentElement'].classList.add('disableimg');
            imgObj['src'] = 'assets/images/disablehome.png';
          } else {
            const imgObj = document.getElementById('dot' + message);
            imgObj['parentElement'].classList.remove('active');
            imgObj['parentElement'].classList.add('disableimg');
            imgObj['src'] = 'assets/images/disabledot.png';
          }
        } else {
          // if (message === '0010' || message === '0015' || message === '0023') {
          if (
            message === '001' ||
            message === '009' ||
            message === '0014' ||
            message === '0020' ||
            message === '0028'
          ) {
            const imgObj = document.getElementById('thunder' + message);
            imgObj['parentElement'].classList.remove('active');
            imgObj['parentElement'].classList.add('disableimg');
            imgObj['src'] = 'assets/images/disablethunder.png';
          } else if (message === '0030') {
            const imgObj = document.getElementById('home');
            imgObj['parentElement'].classList.remove('active');
            imgObj['parentElement'].classList.add('disableimg');
            imgObj['src'] = 'assets/images/disablehome.png';
          } else {
            const imgObj = document.getElementById('dot' + message);
            imgObj['parentElement'].classList.remove('active');
            imgObj['parentElement'].classList.add('disableimg');
            imgObj['src'] = 'assets/images/disabledot.png';
          }
        }
      } else {
        this.percentage -= 4;
        // if (message === '0010' || message === '0015' || message === '0023') {
        if (
          message === '001' ||
          message === '005' ||
          message === '0012' ||
          message === '0017' ||
          message === '0025'
        ) {
          const imgObj = document.getElementById('thunder' + message);
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disablethunder.png';
        } else if (message === '0030') {
          const imgObj = document.getElementById('home');
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disablehome.png';
        } else {
          const imgObj = document.getElementById('dot' + message);
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disabledot.png';
        }
      }
    }
  }

  filter() {
    let ques;
    if (!_.isEmpty(this.residentialService.filteredQues)) {
      ques = this.residentialService.filteredQues;
      const filtered = [];
      for (let i = 0; i < this.questions.length; i++) {
        for (let j = 0; j < ques.length; j++) {
          if (this.questions[i]._id === ques[j]._id) {
            filtered.push(this.questions[i]);
          }
        }
      }
      this.question = filtered;
    } else {
      this.question = this.questions;
    }
  }

  removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

openModal(template: ElementRef<any>) {


  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: 'gray modal-small popup-mx-width'} , this.ngbModalOptions)
  );




}

closeModalWithOutContact() {
  

  this.modalRef.hide();


  
}

Redirect(value){

if(value =="Ques")
{
  this.closeModalWithOutContact();
  this.router.navigateByUrl('/residentialQues');
}else
{
  this.closeModalWithOutContact();
  sessionStorage.removeItem('userResponse')
  sessionStorage.removeItem('questionStatusObj')
  this.router.navigateByUrl('/pre-success');
}

}

addingPadding(){
    
  var bro = this.residentialService.myBrowser();
  if (bro === 'Safari' && this.deviceWidth < 768) {
    return true;
  }

  return false;
}

}
